import { useDispatch, useSelector } from 'react-redux';
import { getWorksheetGridQueryProviderProps } from './providerProps';
import { InjectedPropsProvider } from '../../../Core/InjectedPropsContext';
import { actions } from '../../../../Data/ReduxViewModels/WorksheetGrid';
import React from 'react';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';

let WorksheetGridQueryInjectedPropsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const data = useSelector((s) => s.worksheetGrid.query?.params);
  const setValue = (opts) => dispatch(actions.setQueryValue(opts));
  const submit = () => dispatch(actions.refresh());
  const providerData = {
    data,
    setValue,
    submit,
  };
  return (
    <InjectedPropsProvider
      getProviderProps={(consumerProps, modifiers) =>
        getWorksheetGridQueryProviderProps(consumerProps, providerData, modifiers)
      }
    >
      {children}
    </InjectedPropsProvider>
  );
};

WorksheetGridQueryInjectedPropsProvider = withInjectedProps(WorksheetGridQueryInjectedPropsProvider);

export { WorksheetGridQueryInjectedPropsProvider };
export default WorksheetGridQueryInjectedPropsProvider;
